import PropTypes from "prop-types";
import React from "react";
import { Button, Card } from "reactstrap";
import moment from 'moment'
import { RenderAmount } from "../../utils";
import "./oder-info.scss";

const ExternalOrderInfo = (props) => {
  const {
    id,
    price,
    name,
    address,
    createdAt,
    renderAction,
    item
  } = props;

  return (
    <Card outline className="oder-info border mb-1">
      <div >
        <div className="oder-info_infoCustomer"><b className="text-info">{[name, id].filter(Boolean).join(' - ')}</b></div>
        <div className="oder-info_address text-warning">
          {moment(createdAt).format('HH:mm DD-MM-YYYY')}
        </div>
        <div className="oder-info_address">
          {address}
        </div>
        {price && <div className="oder-info_totalPrice text-primary">
          <RenderAmount price={price} />
        </div>}
        {renderAction?.(item)}
      </div>
    </Card>
  );
};

export default ExternalOrderInfo;

ExternalOrderInfo.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  address: PropTypes.string,
  price: PropTypes.number,
  status: PropTypes.string,
  createdAt: PropTypes.string,
};
